export const changecontractDateReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_CONTRACT_DATE":
        return action.payload.contractDate;
      default:
        return state;
    }
  };
  